import { gql } from "@apollo/client";

// Every query that selects a program asks for the same capabilities, so the cached object keeps all of them.
export const CARD_PROGRAM_CAPABILITY_FIELDS = gql`
  fragment CardProgramCapabilityFields on CardProgram {
    capabilities {
      bankLinkFlow
      latestCardExpiration
      moveFunds
      sendWire
      wireFee
      chargeRepayment
      statements
      physicalCards
      transactionLimit
      dailyLimit
      weeklyLimit
      monthlyLimit
      totalLimit
      merchantLimits
    }
  }
`;

export const CARD_PROGRAM_FIELDS = gql`
  ${CARD_PROGRAM_CAPABILITY_FIELDS}
  fragment CardProgramFields on CardProgram {
    id
    issuer
    nickname
    subAccountType
    status
    isDefault
    last4
    cardHolderType
    ...CardProgramCapabilityFields
  }
`;

export const GET_CARD_PROGRAMS = gql`
  ${CARD_PROGRAM_FIELDS}
  query getCardPrograms($status: [Status]) {
    getCardPrograms(status: $status) {
      ...CardProgramFields
      actionRequired
      connection {
        id
        issuer
        nickname
        status
      }
    }
  }
`;

// The program the owner's rewards bank links under, as the server decides it
export const GET_REWARDS_BANK_PROGRAM = gql`
  ${CARD_PROGRAM_FIELDS}
  query getRewardsBankProgram {
    rewardsBankProgram {
      ...CardProgramFields
    }
  }
`;

// One program by id, a removed one included, which the company's list of programs leaves out.
export const GET_CARD_PROGRAM = gql`
  ${CARD_PROGRAM_FIELDS}
  query getCardProgram($id: ID!) {
    getCardProgram(id: $id) {
      ...CardProgramFields
    }
  }
`;

export const GET_CARD_PROGRAM_REPAYMENT = gql`
  query getCardProgramRepayment($id: ID!) {
    getCardProgram(id: $id) {
      id
      canLinkRepaymentSource
      repaymentSources {
        id
        bankName
        last4
        status
      }
    }
  }
`;
